import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cust-publish",
  "use": "cust-publish-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"cust-publish\"><path fill=\"none\" d=\"M0 0h24v24H0z\" /><path d=\"M5 4v2h14V4zm0 10h4v6h6v-6h4l-7-7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol